var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31652 24.07C2.97937 22.7786 1.91282 21.2338 1.1791 19.5257C0.44537 17.8176 0.0591625 15.9806 0.0430091 14.1217C0.0268556 12.2627 0.381079 10.4192 1.08501 8.69868C1.78894 6.97813 2.82849 5.415 4.14299 4.1005C5.45748 2.78601 7.02061 1.74646 8.74116 1.04253C10.4617 0.338599 12.3052 -0.0156248 14.1641 0.000528595C16.023 0.016682 17.8601 0.402889 19.5682 1.13662C21.2762 1.87034 22.8211 2.93689 24.1125 4.27403C26.6627 6.91447 28.0738 10.4509 28.042 14.1217C28.0101 17.7924 26.5377 21.3038 23.942 23.8995C21.3463 26.4952 17.8349 27.9676 14.1641 27.9995C10.4934 28.0314 6.95695 26.6202 4.31652 24.07ZM22.1385 22.096C24.2401 19.9945 25.4207 17.1441 25.4207 14.172C25.4207 11.2 24.2401 8.34961 22.1385 6.24803C20.0369 4.14646 17.1866 2.96581 14.2145 2.96581C11.2424 2.96581 8.39209 4.14646 6.29052 6.24803C4.18894 8.34961 3.00829 11.2 3.00829 14.172C3.00829 17.1441 4.18894 19.9945 6.29052 22.096C8.39209 24.1976 11.2424 25.3783 14.2145 25.3783C17.1866 25.3783 20.0369 24.1976 22.1385 22.096ZM12.8145 7.17203H15.6145V15.572H12.8145V7.17203ZM12.8145 18.372H15.6145V21.172H12.8145V18.372Z",
    fill: "#0939A5",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9834da1e7de8d8b10c6dc5029105d8bc.svg";
export { ForwardRef as ReactComponent };